export default function Section8() {
    return (
      <footer className="w-full bg-[#1E1926] py-10 text-[18px] text-center text-white poppins-regular">
        <p>© Copyright 2025 All rights reserved to Horizon</p>
      </footer>
    )
  }